import { BASE_PATH as U, BaseAPI as C, operationServerMap as h } from "../base.js";
import { DUMMY_BASE_URL as v, assertParamExists as u, createRequestFunction as y, serializeDataIfNeeded as P, setSearchParams as O, toPathString as V } from "../common.js";
import I from "axios";
var m = function(s) {
  return {
    corpUserAdd: async (a, o = {}) => {
      u("corpUserAdd", "corpUser", a);
      const l = new URL("/corp_user", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserClearAllUserCache: async (a = {}) => {
      const o = new URL("/corp_user/clear_all_user_cache", v);
      let l;
      s && (l = s.baseOptions);
      const r = {
        method: "DELETE",
        ...l,
        ...a
      }, e = {};
      O(o, {});
      let t = l && l.headers ? l.headers : {};
      return r.headers = {
        ...e,
        ...t,
        ...a.headers
      }, {
        url: V(o),
        options: r
      };
    },
    corpUserClearUserCache: async (a, o = {}) => {
      u("corpUserClearUserCache", "corpUserId", a);
      const l = "/corp_user/clear_user_cache/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(a))), r = new URL(l, v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "DELETE",
        ...e,
        ...o
      }, p = {};
      O(r, {});
      let n = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...n,
        ...o.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserCorpUser: async (a, o = {}) => {
      u("corpUserCorpUser", "username", a);
      const l = "/corp_user/info/{username}".replace("{username}", encodeURIComponent(String(a))), r = new URL(l, v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, p = {};
      O(r, {});
      let n = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...n,
        ...o.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserCorpUserByPhone: async (a, o = {}) => {
      u("corpUserCorpUserByPhone", "phone", a);
      const l = "/corp_user/phone/{phone}".replace("{phone}", encodeURIComponent(String(a))), r = new URL(l, v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, p = {};
      O(r, {});
      let n = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...n,
        ...o.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserCorpUserByPhoneInner: async (a, o = {}) => {
      u("corpUserCorpUserByPhoneInner", "phone", a);
      const l = "/corp_user/phone_inner/{phone}".replace("{phone}", encodeURIComponent(String(a))), r = new URL(l, v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, p = {};
      O(r, {});
      let n = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...n,
        ...o.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserDeleteById: async (a, o = {}) => {
      u("corpUserDeleteById", "corpUserId", a);
      const l = "/corp_user/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(a))), r = new URL(l, v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "DELETE",
        ...e,
        ...o
      }, p = {};
      O(r, {});
      let n = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...n,
        ...o.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserEdit: async (a, o = {}) => {
      u("corpUserEdit", "corpUserDTO", a);
      const l = new URL("/corp_user", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserGetPage: async (a, o, l = {}) => {
      u("corpUserGetPage", "corpUser", a), u("corpUserGetPage", "page", o);
      const r = new URL("/corp_user/page", v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...l
      }, p = {}, n = {};
      if (a !== void 0) for (const [d, B] of Object.entries(a)) n[d] = B;
      if (o !== void 0) for (const [d, B] of Object.entries(o)) n[d] = B;
      O(r, n);
      let c = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...c,
        ...l.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserInitPassword: async (a, o = {}) => {
      u("corpUserInitPassword", "corpUserId", a);
      const l = "/corp_user/init_password/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(a))), r = new URL(l, v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, p = {};
      O(r, {});
      let n = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...n,
        ...o.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserListByUnionIds: async (a, o = {}) => {
      u("corpUserListByUnionIds", "requestBody", a);
      const l = new URL("/corp_user/list_by_union_ids", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserLogin: async (a, o = {}) => {
      u("corpUserLogin", "loginVO", a);
      const l = new URL("/corp_user/login", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserQueryById: async (a, o = {}) => {
      u("corpUserQueryById", "requestBody", a);
      const l = new URL("/corp_user/batch", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserQueryByIdV2: async (a, o = {}) => {
      u("corpUserQueryByIdV2", "corpUserId", a);
      const l = "/corp_user/v2/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(a))), r = new URL(l, v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, p = {};
      O(r, {});
      let n = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...n,
        ...o.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserQueryById_1: async (a, o = {}) => {
      u("corpUserQueryById_1", "corpUserId", a);
      const l = "/corp_user/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(a))), r = new URL(l, v);
      let e;
      s && (e = s.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, p = {};
      O(r, {});
      let n = e && e.headers ? e.headers : {};
      return t.headers = {
        ...p,
        ...n,
        ...o.headers
      }, {
        url: V(r),
        options: t
      };
    },
    corpUserQueryPhoneListByIds: async (a, o = {}) => {
      u("corpUserQueryPhoneListByIds", "requestBody", a);
      const l = new URL("/corp_user/batch_phone", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserUpdatePassword: async (a, o = {}) => {
      u("corpUserUpdatePassword", "loginVO", a);
      const l = new URL("/corp_user/update_password", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserUpdatePasswordById: async (a, o = {}) => {
      u("corpUserUpdatePasswordById", "loginVO", a);
      const l = new URL("/corp_user/update_password_by_id", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserUpdatePasswordFirst: async (a, o = {}) => {
      u("corpUserUpdatePasswordFirst", "loginVO", a);
      const l = new URL("/corp_user/update_password_first", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    },
    corpUserWxLogin: async (a, o = {}) => {
      u("corpUserWxLogin", "wxLoginVO", a);
      const l = new URL("/corp_user/wx_login", v);
      let r;
      s && (r = s.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...o
      }, t = {}, p = {};
      t["Content-Type"] = "application/json", O(l, p);
      let n = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...n,
        ...o.headers
      }, e.data = P(a, e, s), {
        url: V(l),
        options: e
      };
    }
  };
}, i = function(s) {
  const a = m(s);
  return {
    async corpUserAdd(o, l) {
      var r, e;
      const t = await a.corpUserAdd(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserAdd"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserClearAllUserCache(o) {
      var l, r;
      const e = await a.corpUserClearAllUserCache(o), t = (l = s == null ? void 0 : s.serverIndex) !== null && l !== void 0 ? l : 0, p = (r = h["CorpUserApi.corpUserClearAllUserCache"]) === null || r === void 0 || (r = r[t]) === null || r === void 0 ? void 0 : r.url;
      return (n, c) => y(e, I, U, s)(n, p || c);
    },
    async corpUserClearUserCache(o, l) {
      var r, e;
      const t = await a.corpUserClearUserCache(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserClearUserCache"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserCorpUser(o, l) {
      var r, e;
      const t = await a.corpUserCorpUser(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserCorpUser"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserCorpUserByPhone(o, l) {
      var r, e;
      const t = await a.corpUserCorpUserByPhone(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserCorpUserByPhone"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserCorpUserByPhoneInner(o, l) {
      var r, e;
      const t = await a.corpUserCorpUserByPhoneInner(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserCorpUserByPhoneInner"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserDeleteById(o, l) {
      var r, e;
      const t = await a.corpUserDeleteById(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserDeleteById"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserEdit(o, l) {
      var r, e;
      const t = await a.corpUserEdit(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserEdit"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserGetPage(o, l, r) {
      var e, t;
      const p = await a.corpUserGetPage(o, l, r), n = (e = s == null ? void 0 : s.serverIndex) !== null && e !== void 0 ? e : 0, c = (t = h["CorpUserApi.corpUserGetPage"]) === null || t === void 0 || (t = t[n]) === null || t === void 0 ? void 0 : t.url;
      return (d, B) => y(p, I, U, s)(d, c || B);
    },
    async corpUserInitPassword(o, l) {
      var r, e;
      const t = await a.corpUserInitPassword(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserInitPassword"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserListByUnionIds(o, l) {
      var r, e;
      const t = await a.corpUserListByUnionIds(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserListByUnionIds"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserLogin(o, l) {
      var r, e;
      const t = await a.corpUserLogin(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserLogin"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserQueryById(o, l) {
      var r, e;
      const t = await a.corpUserQueryById(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserQueryById"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserQueryByIdV2(o, l) {
      var r, e;
      const t = await a.corpUserQueryByIdV2(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserQueryByIdV2"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserQueryById_1(o, l) {
      var r, e;
      const t = await a.corpUserQueryById_1(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserQueryById_1"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserQueryPhoneListByIds(o, l) {
      var r, e;
      const t = await a.corpUserQueryPhoneListByIds(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserQueryPhoneListByIds"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserUpdatePassword(o, l) {
      var r, e;
      const t = await a.corpUserUpdatePassword(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserUpdatePassword"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserUpdatePasswordById(o, l) {
      var r, e;
      const t = await a.corpUserUpdatePasswordById(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserUpdatePasswordById"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserUpdatePasswordFirst(o, l) {
      var r, e;
      const t = await a.corpUserUpdatePasswordFirst(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserUpdatePasswordFirst"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    },
    async corpUserWxLogin(o, l) {
      var r, e;
      const t = await a.corpUserWxLogin(o, l), p = (r = s == null ? void 0 : s.serverIndex) !== null && r !== void 0 ? r : 0, n = (e = h["CorpUserApi.corpUserWxLogin"]) === null || e === void 0 || (e = e[p]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => y(t, I, U, s)(c, n || d);
    }
  };
}, S = function(s, a, o) {
  const l = i(s);
  return {
    corpUserAdd(r, e) {
      return l.corpUserAdd(r.corpUser, e).then((t) => t(o, a));
    },
    corpUserClearAllUserCache(r) {
      return l.corpUserClearAllUserCache(r).then((e) => e(o, a));
    },
    corpUserClearUserCache(r, e) {
      return l.corpUserClearUserCache(r.corpUserId, e).then((t) => t(o, a));
    },
    corpUserCorpUser(r, e) {
      return l.corpUserCorpUser(r.username, e).then((t) => t(o, a));
    },
    corpUserCorpUserByPhone(r, e) {
      return l.corpUserCorpUserByPhone(r.phone, e).then((t) => t(o, a));
    },
    corpUserCorpUserByPhoneInner(r, e) {
      return l.corpUserCorpUserByPhoneInner(r.phone, e).then((t) => t(o, a));
    },
    corpUserDeleteById(r, e) {
      return l.corpUserDeleteById(r.corpUserId, e).then((t) => t(o, a));
    },
    corpUserEdit(r, e) {
      return l.corpUserEdit(r.corpUserDTO, e).then((t) => t(o, a));
    },
    corpUserGetPage(r, e) {
      return l.corpUserGetPage(r.corpUser, r.page, e).then((t) => t(o, a));
    },
    corpUserInitPassword(r, e) {
      return l.corpUserInitPassword(r.corpUserId, e).then((t) => t(o, a));
    },
    corpUserListByUnionIds(r, e) {
      return l.corpUserListByUnionIds(r.requestBody, e).then((t) => t(o, a));
    },
    corpUserLogin(r, e) {
      return l.corpUserLogin(r.loginVO, e).then((t) => t(o, a));
    },
    corpUserQueryById(r, e) {
      return l.corpUserQueryById(r.requestBody, e).then((t) => t(o, a));
    },
    corpUserQueryByIdV2(r, e) {
      return l.corpUserQueryByIdV2(r.corpUserId, e).then((t) => t(o, a));
    },
    corpUserQueryById_1(r, e) {
      return l.corpUserQueryById_1(r.corpUserId, e).then((t) => t(o, a));
    },
    corpUserQueryPhoneListByIds(r, e) {
      return l.corpUserQueryPhoneListByIds(r.requestBody, e).then((t) => t(o, a));
    },
    corpUserUpdatePassword(r, e) {
      return l.corpUserUpdatePassword(r.loginVO, e).then((t) => t(o, a));
    },
    corpUserUpdatePasswordById(r, e) {
      return l.corpUserUpdatePasswordById(r.loginVO, e).then((t) => t(o, a));
    },
    corpUserUpdatePasswordFirst(r, e) {
      return l.corpUserUpdatePasswordFirst(r.loginVO, e).then((t) => t(o, a));
    },
    corpUserWxLogin(r, e) {
      return l.corpUserWxLogin(r.wxLoginVO, e).then((t) => t(o, a));
    }
  };
}, x = class extends C {
  corpUserAdd(s, a) {
    return i(this.configuration).corpUserAdd(s.corpUser, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserClearAllUserCache(s) {
    return i(this.configuration).corpUserClearAllUserCache(s).then((a) => a(this.axios, this.basePath));
  }
  corpUserClearUserCache(s, a) {
    return i(this.configuration).corpUserClearUserCache(s.corpUserId, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserCorpUser(s, a) {
    return i(this.configuration).corpUserCorpUser(s.username, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserCorpUserByPhone(s, a) {
    return i(this.configuration).corpUserCorpUserByPhone(s.phone, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserCorpUserByPhoneInner(s, a) {
    return i(this.configuration).corpUserCorpUserByPhoneInner(s.phone, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserDeleteById(s, a) {
    return i(this.configuration).corpUserDeleteById(s.corpUserId, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserEdit(s, a) {
    return i(this.configuration).corpUserEdit(s.corpUserDTO, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserGetPage(s, a) {
    return i(this.configuration).corpUserGetPage(s.corpUser, s.page, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserInitPassword(s, a) {
    return i(this.configuration).corpUserInitPassword(s.corpUserId, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserListByUnionIds(s, a) {
    return i(this.configuration).corpUserListByUnionIds(s.requestBody, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserLogin(s, a) {
    return i(this.configuration).corpUserLogin(s.loginVO, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserQueryById(s, a) {
    return i(this.configuration).corpUserQueryById(s.requestBody, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserQueryByIdV2(s, a) {
    return i(this.configuration).corpUserQueryByIdV2(s.corpUserId, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserQueryById_1(s, a) {
    return i(this.configuration).corpUserQueryById_1(s.corpUserId, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserQueryPhoneListByIds(s, a) {
    return i(this.configuration).corpUserQueryPhoneListByIds(s.requestBody, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserUpdatePassword(s, a) {
    return i(this.configuration).corpUserUpdatePassword(s.loginVO, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserUpdatePasswordById(s, a) {
    return i(this.configuration).corpUserUpdatePasswordById(s.loginVO, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserUpdatePasswordFirst(s, a) {
    return i(this.configuration).corpUserUpdatePasswordFirst(s.loginVO, a).then((o) => o(this.axios, this.basePath));
  }
  corpUserWxLogin(s, a) {
    return i(this.configuration).corpUserWxLogin(s.wxLoginVO, a).then((o) => o(this.axios, this.basePath));
  }
};
export {
  x as CorpUserApi,
  m as CorpUserApiAxiosParamCreator,
  S as CorpUserApiFactory,
  i as CorpUserApiFp
};

//# sourceMappingURL=corp-user-api.js.map